function o(n) {
  const e = n.toLowerCase().match(/\.([0-9a-z]+)(?:[?#]|$)/);
  return e === null ? null : e[e.length - 1];
}
function t(n, i) {
  if (!n) return !1;
  const e = o(n);
  return i.some((r) => r === e);
}
function u(n) {
  return t(n, [
    "jpeg",
    "jpe",
    "jfif",
    "jpg",
    "png",
    "gif",
    "bmp",
    "tiff",
    "tif",
    "webp",
    "avif",
    "heic",
    "heif",
    "ico",
    "apng",
    "svg"
  ]);
}
function f(n) {
  return t(n, [
    "txt",
    "rtf",
    "md",
    "tex",
    "doc",
    "docx",
    "odt"
  ]);
}
function s(n) {
  return t(n, ["ppt", "pptx", "odp"]);
}
function c(n) {
  return t(n, ["zip", "gz", "rar", "7z", "tar"]);
}
function a(n) {
  return t(n, ["csv", "xls", "xlsx", "ods"]);
}
function p(n) {
  return t(n, ["pdf"]);
}
function m(n) {
  return t(n, [
    "mp3",
    "wav",
    "ogg",
    "m4a",
    "aac",
    "flac",
    "wma",
    "opus"
  ]);
}
function g(n) {
  return t(n, [
    "mp4",
    "webm",
    "mov",
    "avi",
    "mkv",
    "m4v",
    "ogv",
    "wmv",
    "3gp",
    "3g2"
  ]);
}
export {
  o as getExtension,
  t as hasExtension,
  c as isArchive,
  m as isAudio,
  u as isImage,
  p as isPdf,
  s as isPresentation,
  a as isSpreadsheet,
  f as isTextDocument,
  g as isVideo
};
